import BaseModule from "@core/modules/base-module/base-module";
import ArticleStickyBar from "@pj/components/article-sticky-bar/article-sticky-bar";

var stickyBar;
const stickyBarModule = new BaseModule();
//
stickyBarModule.name = "sticky-bar";
stickyBarModule.init((that) => {
  stickyBar = new ArticleStickyBar(that.elements);
  stickyBar.init();
  setTimeout(() => {
    stickyBar.onResize();
  }, 300);
});


stickyBarModule.onResize(() => {
  if (stickyBar) {
    stickyBar.onResize();
  }
});
